import { BASE_URL } from "../api/client.js";

const UPLOAD_BASE = BASE_URL.replace(/\/config\/?$/, "");
// Normalize any stored image value to a working URL. Handles relative paths,
// absolute URLs, and the broken "https://localhost/.../uploads/x" that the
// About Us endpoint returns (we re-anchor anything containing "uploads/").
export const imgUrl = (v) => {
  if (!v) return "";
  const s = String(v);
  const i = s.indexOf("uploads/");
  if (i >= 0) return `${UPLOAD_BASE}/${s.slice(i)}`;
  if (/^https?:\/\//.test(s)) return s;
  return `${UPLOAD_BASE}/${s.replace(/^\//, "")}`;
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.replace(" ", "T"));
  return isNaN(d) ? s : d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
};

export function normalizeList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.orders)) return data.orders;
  return [];
}
